import CrownIcon from "./assets/crown.svg";

export const PlanOptions = [
  {
    title: "Silver Plan",
    isMostPopular: false,
    descriptions: [
      "500 Credits for Image Generation",
      [
        "1 Million Tokens for WeddinglyAi agent",
        "Good for light wedding planning & questions",
      ],
      "Access to all WeddinglyAi AI Models",
      "AI Image Editing (prompt-based)",
    ],
  },
  {
    title: "Gold Plan",
    isMostPopular: true,
    descriptions: [
      "1,000 Credits for Image Generation",
      [
        "2 Million Tokens for WeddinglyAi agent",
        "Detailed wedding planning, ideas & checklists",
      ],
      "No Watermarks",
      "Access to all WeddinglyAi AI Models",
      "AI Image Editing (prompt-based)",
    ],
  },
  {
    title: "Platinum Plan",
    isMostPopular: false,
    icon: CrownIcon,
    descriptions: [
      "2,000 Credits for Image Generation",
      [
        "5 Million Tokens for WeddinglyAi agent",
        "Best for heavy wedding planning",
      ],
      "No Watermarks",
      "Access to all WeddinglyAi AI Models",
      "AI Image Editing (prompt-based)",
    ],
  },
];

export const ModalDescriptions = {
  lessThanRequiredCredits: {
    title: {
      black: "Unlock Your",
      pink: "Dream Wedding",
    },
    description: "You're only a few steps away from creating without limits.",
  },
  outOfCredits: {
    title: {
      black: "You're",
      pink: "Out of Credits",
    },
    description:
      "Subscribe now to unlock more credits and keep your ideas flowing.",
  },
  notEnoughCredits: {
    title: {
      pink: "Not Enough Credits",
      black: "for This Model",
    },
    description:
      "Subscribe to use our most advanced model for next-level wedding visuals.",
  },
};
